.background-white {
  background-color: c("white");
}

.background-titanium {
  background-color: c("titanium");
  color: c("white");
}
.background-titanium-dark {
  background-color: c("titanium-dark");
  color: c("white");
}

.background-neutral01 {
  background-color: c("neutral01");
}

.background-neutral05 {
  background-color: c("neutral05");
}

.background-neutral10 {
  background-color: c("neutral10");
}
.background-neutral15 {
  background-color: c("neutral15");
}
.background-neutral35 {
  background-color: c("neutral35");
}
.background-neutral60 {
  background-color: c("neutral60");
}

.background-transparent {
  background-color: transparent;
}

.background-product-type-color01 {
  background-color: var(--product-type-color-01);
}

.background-product-type-color02 {
  background-color: var(--product-type-color-02);
}

.background-product-type-color03 {
  background-color: var(--product-type-color-03);
}

.background-product-type-color04 {
  background-color: var(--product-type-color-04);
}
